/**
 * Whats New (release notes) domain types.
 * Legacy backend endpoint base: `/api/release_notes`.
 */

export const VERSION_TYPES = {
  PROCESS_CHANGE: 'Process Change',
  PROCESS_IMPROVEMENT: 'Process Improvement',
  NEW_FEATURE: 'New Feature',
} as const

export type VersionType = keyof typeof VERSION_TYPES

export interface ReleaseNote {
  id: number
  version_title: string
  version_description: string
  version_date: string
  version_type: VersionType
  created_at?: string
  updated_at?: string
}

export interface ReleaseNoteListResponse {
  data: ReleaseNote[]
  current: number
  last: number
  total?: number
  per_page?: number
}

export type ReleaseNoteSortKey = 'version_date' | 'version_title' | 'version_type'
export type SortDirection = 'asc' | 'desc'

export interface ReleaseNoteListParams {
  page?: number
  perPage?: number
  orderBy?: ReleaseNoteSortKey
  sortBy?: SortDirection
}

export interface ReleaseNoteSubmitPayload {
  version_title: string
  version_description: string
  version_date: string
  version_type: VersionType
}
